/**
 * Sleep for a certain amount of milliseconds.
 */
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export default sleep;
